import React from "react";
import useCheckoutVisitors from "../../hooks/useCheckoutVisitors";
import pluralize from "pluralize";

const CheckoutLiveVisitors = () => {
  const visitorCount = useCheckoutVisitors();

  return (
    <p className="fs-6 d-flex align-items-center">
      <span
        className="bg-success-100 d-block text-white rounded-circle"
        style={{
          height: 10,
          width: 10,
          marginRight: 5,
        }}
      ></span>
      <span>
        {visitorCount} <span className="fw-bold">{pluralize("person", visitorCount)}</span> {pluralize("is", visitorCount)} viewing this product
      </span>
    </p>
  );
};

export default CheckoutLiveVisitors;
